const convertSecsToMin = (totalSeconds) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes}:${seconds}`;
};

document.addEventListener('DOMContentLoaded', () => {
  const videoContainers = document.querySelectorAll('.video-main');
  console.log('Video controls', videoContainers);

  videoContainers.forEach((videoContainer) => {
    const videoControl = videoContainer.querySelector('.video-controls');
    const playBtn = videoContainer.querySelector('.play-btn');
    const pauseBtn = videoContainer.querySelector('.pause-btn');
    const volumeBtn = videoContainer.querySelector('.volume-btn');
    const muteBtn = videoContainer.querySelector('.mute-btn');
    const video = videoContainer.querySelector('.video');
    const progressBar = videoContainer.querySelector('.progress-bar');
    const fullScreen = videoContainer.querySelector('.fullscreen-btn');
    const progressContainer = videoContainer.querySelector('.progress-container');

    // Hide custom video controls button on iphone/ipad
    // as fullscreen api is not supported on them
     // iPhone detection
   const isiOSDevice = () => {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.userAgent.includes('Macintosh') && 'ontouchend' in document)
    );
  };

  if (isiOSDevice()) {
    console.log("Hiding on iOS device (iPhone/iPad)");
    videoControl.style.display = 'none'; 
    video.controls = true;
    return; // Prevent attaching custom event listeners.
  }

    // const screenWidth = window.innerWidth;
    // console.log('Screen width->', screenWidth);

    // if (screenWidth <= 768) {
    //   video.addEventListener('click', () => {
    //     console.log('Clicked');
    //     if (videoControl.style.bottom == '1rem') {
    //       videoControl.style.bottom = '-7rem';
    //     } else {
    //       videoControl.style.bottom = '1rem';
    //     }
    //   });
    // }

    video.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        playBtn.style.display = 'none';
        pauseBtn.style.display = 'block';
      } else {
        video.pause();
        playBtn.style.display = 'block';
        pauseBtn.style.display = 'none';
      }
    });

    video.addEventListener('timeupdate', () => {
      // if (!isNaN(video.currentTime)) {
      const totalSeconds = video.currentTime;
      const videoLength = video.duration;
      const percentage = (totalSeconds / videoLength) * 100;
      progressBar.style.width = `${percentage}%`;

      // }
    });

    playBtn.addEventListener('click', () => {
      console.log('Play button Clicked');
      playBtn.style.display = 'none';
      pauseBtn.style.display = 'block';
      video.play();
    });
    pauseBtn.addEventListener('click', () => {
      console.log('Clicked');
      playBtn.style.display = 'block';
      pauseBtn.style.display = 'none';
      video.pause();
    });
    fullScreen.addEventListener('click', () => {
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.mozRequestFullScreen) {
        // Firefox
        video.mozRequestFullScreen();
      } else if (video.webkitRequestFullscreen) {
        // Chrome, Safari, Edge
        video.webkitRequestFullscreen();
      } else if (video.msRequestFullscreen) {
        // IE/Edge
        video.msRequestFullscreen();
      }
    });
    volumeBtn.addEventListener('click', () => {
      video.muted = true;
      volumeBtn.style.display = 'none';
      muteBtn.style.display = 'block';
    });
    muteBtn.addEventListener('click', () => {
      video.muted = false;
      volumeBtn.style.display = 'block';
      muteBtn.style.display = 'none';
    });

    const updateProgress = (event) => {
      const rect = progressContainer.getBoundingClientRect();
      const clickX = event.clientX - rect.left;
      const width = rect.width;
      const percentage = Math.min(Math.max(clickX / width, 0), 1); // Keep within bounds
      progressBar.style.width = `${percentage * 100}%`;
      video.currentTime = percentage * video.duration;
    };

    // Click to seek
    progressContainer.addEventListener('click', updateProgress);

    let isDragging = false;

    // Dragging functionality
    progressContainer.addEventListener('mousedown', (event) => {
      isDragging = true;
      updateProgress(event);
    });

    document.addEventListener('mousemove', (event) => {
      if (isDragging) {
        updateProgress(event);
      }
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
    });

    document.addEventListener('mouseleave', () => {
      isDragging = false;
    });
  });
});
